import React from 'react';

import Strings from '../../../Strings';
import { chartTypeEnum } from "../../../components/Graphs/GenericCategoryGraph";
import ReadingsWidget, { WidgetTypes } from "../../Dashboards/Widgets/ReadingsWidget";
import { customFormattingConfig, horizontalChartTypeConfig, simpleChartTypeWithNumbersConfig, stackedChartTypeConfig, verticalChartTypeConfig } from "../../Dashboards/Widgets/WidgetConfigs";

// #region dashboard definitions
export const DASHBOARD_ID = 'BusinessReportEnrollmentsDashboard_1';
export const OVERALL_DASHBOARD_ID = 'BusinessReportOverallDashboard_1';
export const SHIPMENTS_DASHBOARD_ID = 'BusinessReportShipmentsDashboard_1';
export const DEVICE_UTILIZATION_DASHBOARD_ID = 'BusinessReportDeviceUtilizationDashboard_1';
export const ORGANIZATIONS_DASHBOARD_ID = 'BusinessReportOrganizationsDashboard_1';

export const chartTypeConfig = {
  stackedChartType: {
    type: 'select',
    name: 'stackedChartType',
    label: 'Stacked Chart Type',
    defaultValue: chartTypeEnum.stackedPie,
    options: [
      { label: 'Stacked Bar chart', value: chartTypeEnum.stackedBar },
      { label: 'Stacked Horizontal Bar', value: chartTypeEnum.horizontalStackedBar },
      { label: 'Stacked Area chart', value: chartTypeEnum.stackedArea },
      { label: 'Stacked Pie chart', value: chartTypeEnum.stackedPie },
      { label: 'Line chart', value: chartTypeEnum.line },
    ],
    canBeSetByDashboard: false,
  },
};

export const EnrollmentsWithNoCptCodesRpmMetadata = {
  id: 'EnrollmentsWithNoCptCodesRpm',
  name: 'RPM - Enrollments with no CPT code',
  group: 'RPM',
  permission: '',
  defProps: { i: 'EnrollmentsWithNoCptCodesRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const EnrollmentsWithNoCptCodesRtmMetadata = {
  id: 'EnrollmentsWithNoCptCodesRtm',
  name: 'RTM - Enrollments with no CPT code',
  group: 'RTM',
  permission: '',
  defProps: { i: 'EnrollmentsWithNoCptCodesRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith20minCodeRtmMetadata = {
  id: 'PatientsWith20minCodeRtm',
  name: 'RTM - Enrollments with 20 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith20minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith40minCodeRtmMetadata = {
  id: 'PatientsWith40minCodeRtm',
  name: 'RTM - Enrollments with 40 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith40minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith60minCodeRtmMetadata = {
  id: 'PatientsWith60minCodeRtm',
  name: 'RTM - Enrollments with 60 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith60minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith20minCodeRpmMetadata = {
  id: 'PatientsWith20minCodeRpm',
  name: 'RPM - Enrollments with 20 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith20minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith40minCodeRpmMetadata = {
  id: 'PatientsWith40minCodeRpm',
  name: 'RPM - Enrollments with 40 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith40minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith60minCodeRpmMetadata = {
  id: 'PatientsWith60minCodeRpm',
  name: 'RPM - Enrollments with 60 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith60minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWoMonitoringCodeRtmRespMetadata = {
  id: 'PatientsWoMonitoringCodeRtmResp',
  name: 'RTM Resp - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmResp', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWoMonitoringCodeRtmMsMetadata = {
  id: 'PatientsWoMonitoringCodeRtmMS',
  name: 'RTM Musc - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmMS', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const PatientsWoMonitoringCodeRtmBehavMetadata = {
  id: 'PatientsWoMonitoringCodeRtmBehav',
  name: 'RTM Bhv - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmBehav', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const PatientsWoMonitoringCodeRpmMetadata = {
  id: 'PatientsWoMonitoringCodeRpm',
  name: 'RPM - Enrollments with no monitoring code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const AvgEnrollmentTimeRpmMetadata = {
  id: 'AvgEnrollmentTimeRpm',
  name: 'RPM - Avg Enrollment Time',
  group: 'RPM',
  permission: '',
  defProps: { i: 'AvgEnrollmentTimeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const AvgEnrollmentTimeRtmMetadata = {
  id: 'AvgEnrollmentTimeRtm',
  name: 'RTM - Avg Enrollment Time',
  group: 'RTM',
  permission: '',
  defProps: { i: 'AvgEnrollmentTimeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const NewEnrollmentsRpmMetadata = {
  id: 'NewEnrollmentsRpm',
  name: 'RPM - New Enrollments',
  group: 'RPM',
  permission: '',
  defProps: { i: 'NewEnrollmentsRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const NewEnrollmentsRtmMetadata = {
  id: 'NewEnrollmentsRtm',
  name: 'RTM - New Enrollments',
  group: 'RTM',
  permission: '',
  defProps: { i: 'NewEnrollmentsRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const AdherenceDistributionMetadata = {
  id: 'AdherenceDistribution',
  name: 'Adherence Distribution',
  permission: '',
  defProps: { i: 'AdherenceDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: verticalChartTypeConfig,
};

export const OrgsStateMetadata = {
  id: 'OrgsState',
  name: 'All Organizations State',
  group: 'Organizations',
  permission: '',
  defProps: { i: 'OrgsState', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Stacked Chart Type',
      defaultValue: chartTypeEnum.stackedBar,
      options: [
        { label: 'Stacked Bar', value: chartTypeEnum.stackedBar },
        { label: 'Stacked Horizontal Bar', value: chartTypeEnum.horizontalStackedBar },
      ],
      canBeSetByDashboard: false,
    },
  },
};

export const OrgsAdministrativeStateMetadata = {
  id: 'OrgsAdministrativeState',
  name: 'All Organizations Administrative State',
  group: 'Organizations',
  permission: '',
  defProps: { i: 'OrgsAdministrativeState', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...horizontalChartTypeConfig.chartType, defaultValue: chartTypeEnum.pie},
  },
};
export const OrgsBusinessStateMetadata = {
  id: 'OrgsBusinessState',
  name: 'All Organizations Business State',
  group: 'Organizations',
  permission: '',
  defProps: { i: 'OrgsBusinessState', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...horizontalChartTypeConfig.chartType, defaultValue: chartTypeEnum.pie},
  },
};

export const OrgsOperationalStateMetadata = {
  id: 'OrgsOperationalState',
  name: 'All Organizations Operational State',
  group: 'Organizations',
  permission: '',
  defProps: { i: 'OrgsOperationalState', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...horizontalChartTypeConfig.chartType, defaultValue: chartTypeEnum.pie},
  },
};

export const NewOrganizationsByTypeMetadata = {
  id: 'NewOrganizationsByType',
  name: 'New Organizations by Type',
  group: 'Organizations',
  permission: '',
  defProps: { i: 'NewOrganizationsByType', w: 12, h: 5, minW: 4, minH: 4 },
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Chart Type',
      defaultValue: chartTypeEnum.stackedBar,
      options: [
        { label: 'Stacked Bar', value: chartTypeEnum.stackedBar },
        { label: 'Stacked Area', value: chartTypeEnum.stackedArea },
        { label: 'Line chart', value: chartTypeEnum.line },
      ],
      canBeSetByDashboard: false,
    },
  },
};

const createOrganizationsRankingMetadata = (id, name) => ({
  id,
  name,
  group: 'Organizations',
  permission: '',
  defProps: { i: id, w: 6, h: 6, minW: 3, minH: 4 },
  configuration: horizontalChartTypeConfig,
});

export const OrganizationsByPatientsMetadata = createOrganizationsRankingMetadata(
  'OrganizationsByPatients',
  'Organizations by Patients',
);
export const OrganizationsByEnrollmentsMetadata = createOrganizationsRankingMetadata(
  'OrganizationsByEnrollments',
  'Organizations by Active Enrollments',
);
export const OrganizationsByKitsOrderedMetadata = {
  ...createOrganizationsRankingMetadata(
    'OrganizationsByKitsOrdered',
    'Organizations by Total Kits Ordered',
  ),
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Chart Type',
      defaultValue: chartTypeEnum.horizontalStackedBar,
      options: [
        { label: 'Horizontal stacked bar', value: chartTypeEnum.horizontalStackedBar },
        { label: 'Horizontal bar', value: chartTypeEnum.horizontalBar },
      ],
      canBeSetByDashboard: false,
    },
  },
};
export const OrganizationsByDevicesOrderedMetadata = createOrganizationsRankingMetadata(
  'OrganizationsByDevicesOrdered',
  'Organizations by Total Devices Ordered',
);

export const UniquePatientsTrendMetadata = {
  id: 'UniquePatientsTrend',
  name: 'Unique Patients Over Time',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'UniquePatientsTrend', w: 5, h: 4, minW: 3, minH: 4 },
  configuration: verticalChartTypeConfig,
};

export const OverallActivePatientsMetadata = {
  id: 'OverallActivePatients',
  name: 'Active Patients',
  group: 'Overall',
  permission: '',
  defProps: { i: 'OverallActivePatients', w: 3, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
  description: 'Total amount of patients with active enrollment',
};

export const OverallAllPatientsMetadata = {
  id: 'OverallAllPatients',
  name: 'All Patients',
  group: 'Overall',
  permission: '',
  defProps: { i: 'OverallAllPatients', w: 3, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
  description: 'Total amount of all patients without disenrolled or not enrolled patients',
};

const createOverallTrendMetadata = (id, name, configuration = verticalChartTypeConfig) => ({
  id,
  name,
  group: 'Overall',
  permission: '',
  defProps: { i: id, w: 6, h: 5, minW: 3, minH: 4 },
  configuration,
});

const overallLineTrendTypeConfig = {
  chartType: {
    ...verticalChartTypeConfig.chartType,
    defaultValue: chartTypeEnum.line,
  },
};

export const OverallNewPatientsTrendMetadata = createOverallTrendMetadata(
  'OverallNewPatientsTrend',
  'New Patients',
  overallLineTrendTypeConfig,
);
export const OverallNewEnrollmentsTrendMetadata = createOverallTrendMetadata(
  'OverallNewEnrollmentsTrend',
  'New Enrollments',
  overallLineTrendTypeConfig,
);
export const OverallActiveEnrollmentsTrendMetadata = createOverallTrendMetadata('OverallActiveEnrollmentsTrend', 'Active Patients');
export const OverallPatientsCountTrendMetadata = createOverallTrendMetadata('OverallPatientsCountTrend', 'Patients Count');
export const OverallDisenrollmentsTrendMetadata = createOverallTrendMetadata(
  'OverallDisenrollmentsTrend',
  'Total Disenrollments',
);
export const OverallDisenrollmentReasonsTrendMetadata = createOverallTrendMetadata(
  'OverallDisenrollmentReasonsTrend',
  'Disenrollment Reasons',
  stackedChartTypeConfig,
);
export const OverallNotEnrolledTrendMetadata = createOverallTrendMetadata(
  'OverallNotEnrolledTrend',
  'Total Not Enrolled',
);
export const OverallNotEnrolledReasonsTrendMetadata = createOverallTrendMetadata(
  'OverallNotEnrolledReasonsTrend',
  'Not Enrolled Reasons',
  stackedChartTypeConfig,
);
OverallNewPatientsTrendMetadata.description = 'Amount of new patients over time';
OverallNewEnrollmentsTrendMetadata.description = 'Amount of new enrollments over time';
OverallActiveEnrollmentsTrendMetadata.description = 'Amount of patients with active enrollment over time';
OverallPatientsCountTrendMetadata.description = 'Total amount of patients at the end of each period, excluding patients with only disenrolled or not enrolled enrollments';
OverallDisenrollmentsTrendMetadata.description = 'Total amount of disnerollments over the time';
OverallDisenrollmentReasonsTrendMetadata.description = 'Disenrollment reasons for new disenrollments over time';
OverallNotEnrolledTrendMetadata.description = 'Total amount of not enrolled patients over time';
OverallNotEnrolledReasonsTrendMetadata.description = 'Not enrolled reasons for new not enrolled patients over time';

export const AvgTimeInProgramTrendMetadata = {
  id: 'AvgTimeInProgramTrend',
  name: 'Avg Time in Program Over Time',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'AvgTimeInProgramTrend', w: 5, h: 4, minW: 3, minH: 4 },
  configuration: verticalChartTypeConfig,
};

export const EligibleToEnrolledRatioMetadata = {
  id: 'EligibleToEnrolledRatio',
  name: 'Enrolled / Eligible Over Time',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'EligibleToEnrolledRatio', w: 4, h: 4, minW: 3, minH: 4 },
  configuration: verticalChartTypeConfig,
};

const createTransitionTimeMetadata = (id, name) => ({
  id,
  name,
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: id, w: 4, h: 4, minW: 3, minH: 4 },
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Chart Type',
      defaultValue: chartTypeEnum.line,
      options: [
        { label: 'Line chart', value: chartTypeEnum.line },
        { label: 'Bar chart', value: chartTypeEnum.bar },
        { label: 'Area chart', value: chartTypeEnum.area },
      ],
      canBeSetByDashboard: false,
    },
  },
});

export const OnboardedToRegisteredTrendMetadata = createTransitionTimeMetadata(
  'OnboardedToRegisteredTrend',
  'Avg Time: Onboarded to Registered',
);
export const RegisteredToEnrolledTrendMetadata = createTransitionTimeMetadata(
  'RegisteredToEnrolledTrend',
  'Avg Time: Registered to Enrolled',
);
export const EnrolledToActivatedTrendMetadata = createTransitionTimeMetadata(
  'EnrolledToActivatedTrend',
  'Avg Time: Enrolled to Activated',
);

export const ENROLLMENT_TREND_STATUSES = [
  { key: 'onboarded', label: 'Onboarded Patients' },
  { key: 'registered', label: 'Registered Patients' },
  { key: 'enrolled', label: 'Pre-activation Enrollments' },
  { key: 'activated', label: 'Active Enrollments' },
  { key: 'disenrolled', label: 'Disenrolled' },
  { key: 'notEnrolled', label: 'Not Enrolled' },
];

const createEnrollmentTrendMetadata = (prefix, statusKey, statusLabel) => ({
  id: `${prefix}${statusKey.charAt(0).toUpperCase()}${statusKey.slice(1)}`,
  name: `${statusLabel} ${prefix === 'EnrollmentEvents' ? 'Changes Over Time' : 'at Period End'}`,
  group: 'Enrollment Summary',
  permission: '',
  defProps: {
    i: `${prefix}${statusKey.charAt(0).toUpperCase()}${statusKey.slice(1)}`,
    w: 6,
    h: 5,
    minW: 3,
    minH: 4,
  },
  configuration: verticalChartTypeConfig,
});

export const EnrollmentEventTrendMetadata = ENROLLMENT_TREND_STATUSES.map(status =>
  createEnrollmentTrendMetadata('EnrollmentEvents', status.key, status.label));
export const EnrollmentSnapshotTrendMetadata = ENROLLMENT_TREND_STATUSES.map(status =>
  createEnrollmentTrendMetadata('EnrollmentSnapshot', status.key, status.label));

export const DisenrollmentReasonsMetadata = {
  id: 'DisenrollmentReasons',
  name: 'Disenrollment Reasons',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'DisenrollmentReasons', w: 4, h: 6, minW: 3, minH: 4 },
  configuration: horizontalChartTypeConfig,
};

export const NotEnrolledReasonsMetadata = {
  id: 'NotEnrolledReasons',
  name: 'Not Enrolled Reasons',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'NotEnrolledReasons', w: 4, h: 6, minW: 3, minH: 4 },
  configuration: horizontalChartTypeConfig,
};

export const NotEnrolledRecoveriesMetadata = {
  id: 'NotEnrolledRecoveries',
  name: 'Moved Out of Not Enrolled',
  group: 'Enrollment Summary',
  permission: '',
  defProps: { i: 'NotEnrolledRecoveries', w: 4, h: 6, minW: 3, minH: 4 },
  configuration: horizontalChartTypeConfig,
};

const createShipmentTrendMetadata = (id, name) => ({
  id,
  name,
  group: 'Shipment Summary',
  permission: '',
  defProps: { i: id, w: 4, h: 4, minW: 3, minH: 4 },
  configuration: verticalChartTypeConfig,
});

export const KitsOrderedTrendMetadata = {
  ...createShipmentTrendMetadata('KitsOrderedTrend', 'Kits Ordered Over Time (Direct shipment)'),
  configuration: stackedChartTypeConfig,
};
export const KitsOrderedTotalTrendMetadata = createShipmentTrendMetadata('KitsOrderedTotalTrend', 'Kits Ordered Over Time (Direct + Bulk)');
export const BulkKitsOrderedTrendMetadata = createShipmentTrendMetadata('BulkKitsOrderedTrend', 'Kits Ordered Over Time (Bulk shipment)');
export const KitsShippedTrendMetadata = {
  ...createShipmentTrendMetadata('KitsShippedTrend', 'Kits Shipped Over Time (Direct shipment)'),
  configuration: stackedChartTypeConfig,
};
export const KitsShippedTotalTrendMetadata = createShipmentTrendMetadata('KitsShippedTotalTrend', 'Kits Shipped Over Time (Direct + Bulk)');
export const BulkKitsShippedTrendMetadata = createShipmentTrendMetadata('BulkKitsShippedTrend', 'Kits Shipped Over Time (Bulk shipment)');
export const DevicesShippedTrendMetadata = createShipmentTrendMetadata('DevicesShippedTrend', 'Devices Shipped Over Time (Direct shipment)');
export const DevicesShippedTotalTrendMetadata = createShipmentTrendMetadata('DevicesShippedTotalTrend', 'Devices Shipped Over Time (Direct + Bulk)');
export const BulkDevicesShippedTrendMetadata = createShipmentTrendMetadata('BulkDevicesShippedTrend', 'Devices Shipped Over Time (Bulk shipment)');
export const TotalKitsOrderedTrendMetadata = {
  ...createShipmentTrendMetadata('TotalKitsOrderedTrend', 'Total Kits Ordered Over Time'),
  configuration: {
    ...stackedChartTypeConfig,
    stackedChartType: {
      ...stackedChartTypeConfig.stackedChartType,
      defaultValue: chartTypeEnum.line,
    },
  },
  description: 'Shows the cumulative total number of kits ordered up to the end of each period, split by direct and bulk shipments.',
};
export const TotalKitsShippedTrendMetadata = {
  ...createShipmentTrendMetadata('TotalKitsShippedTrend', 'Total Kits Shipped Over Time'),
  configuration: {
    ...stackedChartTypeConfig,
    stackedChartType: {
      ...stackedChartTypeConfig.stackedChartType,
      defaultValue: chartTypeEnum.line,
    },
  },
  description: 'Shows the cumulative total number of kits shipped up to the end of each period, split by direct and bulk shipments.',
};
export const TotalDevicesShippedTrendMetadata = {
  ...createShipmentTrendMetadata('TotalDevicesShippedTrend', 'Total Devices Shipped Over Time'),
  configuration: {
    ...stackedChartTypeConfig,
    stackedChartType: {
      ...stackedChartTypeConfig.stackedChartType,
      defaultValue: chartTypeEnum.line,
    },
  },
  description: 'Shows the cumulative total number of devices shipped up to the end of each period, split by direct and bulk shipments.',
};
export const KitsShippingQueueTrendMetadata = {
  ...createShipmentTrendMetadata('KitsShippingQueueTrend', 'Kits shipping queue'),
  defProps: { i: 'KitsShippingQueueTrend', w: 12, h: 4, minW: 4, minH: 4 },
  configuration: {
    ...verticalChartTypeConfig,
    chartType: {
      ...verticalChartTypeConfig.chartType,
      defaultValue: chartTypeEnum.line,
    },
  },
};
export const AvgOrderToShippedTrendMetadata = createShipmentTrendMetadata('AvgOrderToShippedTrend', 'Avg Order to Shipped (Direct shipment)');
export const BulkAvgOrderToShippedTrendMetadata = createShipmentTrendMetadata('BulkAvgOrderToShippedTrend', 'Avg Order to Shipped (Bulk shipment)');
export const AvgShippedToActivatedTrendMetadata = createShipmentTrendMetadata('AvgShippedToActivatedTrend', 'Avg Shipped to Activated (Direct shipment)');
KitsOrderedTotalTrendMetadata.description = 'Shows the total number of kits ordered in each period across direct and bulk shipments.';
KitsShippedTotalTrendMetadata.description = 'Shows the total number of kits shipped in each period across direct and bulk shipments.';
DevicesShippedTotalTrendMetadata.description = 'Shows the total number of devices shipped in each period across direct and bulk shipments.';
KitsShippingQueueTrendMetadata.description = 'Calculated as cumulative kits ordered minus cumulative kits shipped as of the end of each period.';
export const KitUsageTrendMetadata = {
  ...createShipmentTrendMetadata('KitUsageTrend', 'Average Kit Usage for Kits in Enrollments'),
  description:
    'Shows the average usage across kits assigned to active enrollments in the selected period. A kit is counted as active for a given day if it has at least one measurement on that day.',
};
export const DeviceUsageTrendMetadata = {
  ...createShipmentTrendMetadata('DeviceUsageTrend', 'Average Device Usage for Devices in Enrollments'),
  description:
    'Shows the average usage across devices assigned to active enrollments in the selected period. A device is counted as active for a given day if it has at least one measurement on that day.',
};
export const AssignedKitsTrendMetadata = {
  ...createShipmentTrendMetadata('AssignedKitsTrend', 'Kits Assigned to Enrollments'),
  description:
    'Shows the number of unique accepted kits assigned to active enrollments in the selected period.',
};
export const AssignedDevicesTrendMetadata = {
  ...createShipmentTrendMetadata('AssignedDevicesTrend', 'Devices Assigned to Enrollments'),
  description:
    'Shows the number of devices in accepted kits assigned to active enrollments in the selected period.',
};

const capActivityChartConfig = config => ({
  chartType: {
    ...config.chartType,
    label: Strings.capActivity.chartType,
    options: config.chartType.options.map(option => ({
      ...option,
      label: Strings.capActivity[option.value === chartTypeEnum.bar ? 'bar' : option.value === chartTypeEnum.area ? 'area' :
        option.value === chartTypeEnum.line ? 'line' : 'pie'],
    })),
  },
});

export const CapsLastTakeMetadata = {
  id: 'CapsLastTake',
  name: Strings.capActivity.lastTakeTitle,
  group: Strings.capActivity.group,
  permission: '',
  defProps: { i: 'CapsLastTake', w: 6, h: 6, minW: 3, minH: 4 },
  configuration: capActivityChartConfig(verticalChartTypeConfig),
  description: Strings.capActivity.lastTakeDescription,
};
export const DevicesLastActivityMetadata = {
  id: 'DevicesLastActivity',
  name: Strings.capActivity.lastActivityTitle,
  group: Strings.capActivity.group,
  permission: '',
  defProps: { i: 'DevicesLastActivity', w: 6, h: 6, minW: 3, minH: 4 },
  configuration: capActivityChartConfig(verticalChartTypeConfig),
  description: Strings.capActivity.lastActivityDescription,
};
export const ShipmentMethodSplitMetadata = {
  id: 'ShipmentMethodSplit',
  name: 'Direct Shipment Method Split',
  group: 'Shipment Summary',
  permission: '',
  defProps: { i: 'ShipmentMethodSplit', w: 6, h: 6, minW: 3, minH: 4 },
  configuration: horizontalChartTypeConfig,
};

export const RTMNumberOfCptCodesMetadata = {
  id: 'RTMNumberOfCptCodes',
  group: 'RTM',
  name: 'RTM - number of CPT Codes',
  permission: '',
  defProps: { i: 'RTMNumberOfCptCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...simpleChartTypeWithNumbersConfig.chartType, defaultValue: chartTypeEnum.horizontalBar},
  },
};
export const RPMNumberOfCptCodesMetadata = {
  id: 'RPMNumberOfCptCodes',
  group: 'RPM',
  name: 'RPM - number of CPT Codes',
  permission: '',
  defProps: { i: 'RPMNumberOfCptCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...simpleChartTypeWithNumbersConfig.chartType, defaultValue: chartTypeEnum.horizontalBar},
  },
};

export const RTMCptCodesDistributionMetadata = {
  id: 'RTMCptCodesDistribution',
  group: 'RTM',
  name: 'RTM - CPT Codes Distribution',
  permission: '',
  defProps: { i: 'RTMCptCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: simpleChartTypeWithNumbersConfig,
};
export const RPMCptCodesDistributionMetadata = {
  id: 'RPMCptCodesDistribution',
  group: 'RPM',
  name: 'RPM - CPT Codes Distribution',
  permission: '',
  defProps: { i: 'RPMCptCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: simpleChartTypeWithNumbersConfig,
};

export const RTMTimeCodesMetadata = {
  id: 'RTMTimeCodes',
  group: 'RTM',
  name: 'RTM - 20, 40, 60 Minutes Codes Distribution',
  permission: '',
  defProps: { i: 'RTMTimeCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: chartTypeConfig,
};
export const RPMTimeCodesMetadata = {
  group: 'RPM',
  id: 'RPMTimeCodes',
  name: 'RPM - 20, 40, 60 Minutes Codes Distribution',
  permission: '',
  defProps: { i: 'RPMTimeCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: chartTypeConfig,
};
export const RTMMonitoringCodesDistributionMetadata = {
  group: 'RTM',
  id: 'RTMMonitoringCodesDistribution',
  name: 'RTM - Monitoring Codes Distribution',
  permission: '',
  defProps: { i: 'RTMMonitoringCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Chart Type',
      defaultValue: chartTypeEnum.hierarchicalPie,
      options: [
        { label: 'Stacked Bar chart', value: chartTypeEnum.stackedBar },
        { label: 'Stacked Area chart', value: chartTypeEnum.stackedArea },
        { label: 'Stacked Horizontal Bar', value: chartTypeEnum.horizontalStackedBar },
        { label: 'Hierarchical Pie chart', value: chartTypeEnum.hierarchicalPie },
      ],
      canBeSetByDashboard: false,
    },
  },
};
export const RPMMonitoringCodesDistributionMetadata = {
  id: 'RPMMonitoringCodesDistribution',
  group: 'RPM',
  name: 'RPM - Monitoring Codes Distribution',
  permission: '',
  defProps: { i: 'RPMMonitoringCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
};

export const getWidgetMetadata = () => ([
  UniquePatientsTrendMetadata,
  AvgTimeInProgramTrendMetadata,
  EligibleToEnrolledRatioMetadata,
  OnboardedToRegisteredTrendMetadata,
  RegisteredToEnrolledTrendMetadata,
  EnrolledToActivatedTrendMetadata,
  ...EnrollmentEventTrendMetadata,
  ...EnrollmentSnapshotTrendMetadata,
  DisenrollmentReasonsMetadata,
  NotEnrolledReasonsMetadata,
  NotEnrolledRecoveriesMetadata,
]);

export const getShipmentsWidgetMetadata = () => ([
  KitsOrderedTotalTrendMetadata,
  TotalKitsOrderedTrendMetadata,
  KitsOrderedTrendMetadata,
  KitsShippedTotalTrendMetadata,
  TotalKitsShippedTrendMetadata,
  KitsShippedTrendMetadata,
  DevicesShippedTotalTrendMetadata,
  TotalDevicesShippedTrendMetadata,
  KitsShippingQueueTrendMetadata,
  DevicesShippedTrendMetadata,
  AvgOrderToShippedTrendMetadata,
  AvgShippedToActivatedTrendMetadata,
  ShipmentMethodSplitMetadata,
  BulkKitsOrderedTrendMetadata,
  BulkKitsShippedTrendMetadata,
  BulkDevicesShippedTrendMetadata,
  BulkAvgOrderToShippedTrendMetadata,
]);

export const getOverallWidgetMetadata = () => ([
  OverallActivePatientsMetadata,
  OverallAllPatientsMetadata,
  OverallNewPatientsTrendMetadata,
  OverallNewEnrollmentsTrendMetadata,
  OverallActiveEnrollmentsTrendMetadata,
  OverallPatientsCountTrendMetadata,
  OverallDisenrollmentsTrendMetadata,
  OverallDisenrollmentReasonsTrendMetadata,
  OverallNotEnrolledTrendMetadata,
  OverallNotEnrolledReasonsTrendMetadata,
]);

export const getDeviceUtilizationWidgetMetadata = () => ([
  CapsLastTakeMetadata,
  DevicesLastActivityMetadata,
  KitUsageTrendMetadata,
  DeviceUsageTrendMetadata,
  AssignedKitsTrendMetadata,
  AssignedDevicesTrendMetadata,
]);

export const getOrganizationsWidgetMetadata = () => ([
  OrgsStateMetadata,
  OrgsAdministrativeStateMetadata,
  OrgsBusinessStateMetadata,
  OrgsOperationalStateMetadata,
  NewOrganizationsByTypeMetadata,
  OrganizationsByPatientsMetadata,
  OrganizationsByEnrollmentsMetadata,
  OrganizationsByKitsOrderedMetadata,
  OrganizationsByDevicesOrderedMetadata,
]);

const getEnrollmentsL = () => {
  return [
    { ...UniquePatientsTrendMetadata.defProps, x: 0, y: 0, w: 6, h: 4 },
    { ...EligibleToEnrolledRatioMetadata.defProps, x: 6, y: 0, w: 6, h: 4 },
    { ...AvgTimeInProgramTrendMetadata.defProps, x: 0, y: 4, w: 12, h: 4 },
    { ...EnrollmentEventTrendMetadata[0].defProps, x: 0, y: 8, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[0].defProps, x: 6, y: 8, w: 6, h: 5 },
    { ...EnrollmentEventTrendMetadata[1].defProps, x: 0, y: 13, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[1].defProps, x: 6, y: 13, w: 6, h: 5 },
    { ...EnrollmentEventTrendMetadata[2].defProps, x: 0, y: 18, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[2].defProps, x: 6, y: 18, w: 6, h: 5 },
    { ...EnrollmentEventTrendMetadata[3].defProps, x: 0, y: 23, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[3].defProps, x: 6, y: 23, w: 6, h: 5 },
    { ...OnboardedToRegisteredTrendMetadata.defProps, x: 0, y: 28, w: 12, h: 4 },
    { ...RegisteredToEnrolledTrendMetadata.defProps, x: 0, y: 32, w: 12, h: 4 },
    { ...EnrolledToActivatedTrendMetadata.defProps, x: 0, y: 36, w: 12, h: 4 },
    { ...EnrollmentEventTrendMetadata[4].defProps, x: 0, y: 40, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[4].defProps, x: 6, y: 40, w: 6, h: 5 },
    { ...EnrollmentEventTrendMetadata[5].defProps, x: 0, y: 45, w: 6, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[5].defProps, x: 6, y: 45, w: 6, h: 5 },
    { ...DisenrollmentReasonsMetadata.defProps, x: 0, y: 50, w: 4, h: 6 },
    { ...NotEnrolledReasonsMetadata.defProps, x: 4, y: 50, w: 4, h: 6 },
    { ...NotEnrolledRecoveriesMetadata.defProps, x: 8, y: 50, w: 4, h: 6 },
  ];
};

const getOverallL = () => ([
  { ...OverallActivePatientsMetadata.defProps, x: 2, y: 0, w: 3, h: 2 },
  { ...OverallAllPatientsMetadata.defProps, x: 7, y: 0, w: 3, h: 2 },
  { ...OverallActiveEnrollmentsTrendMetadata.defProps, x: 0, y: 2, w: 6, h: 5 },
  { ...OverallPatientsCountTrendMetadata.defProps, x: 6, y: 2, w: 6, h: 5 },
  { ...OverallNewPatientsTrendMetadata.defProps, x: 0, y: 7, w: 6, h: 5 },
  { ...OverallNewEnrollmentsTrendMetadata.defProps, x: 6, y: 7, w: 6, h: 5 },
  { ...OverallDisenrollmentsTrendMetadata.defProps, x: 0, y: 12, w: 6, h: 5 },
  { ...OverallDisenrollmentReasonsTrendMetadata.defProps, x: 6, y: 12, w: 6, h: 5 },
  { ...OverallNotEnrolledTrendMetadata.defProps, x: 0, y: 17, w: 6, h: 5 },
  { ...OverallNotEnrolledReasonsTrendMetadata.defProps, x: 6, y: 17, w: 6, h: 5 },
]);

const getShipmentsL = () => ([
  { ...KitsOrderedTotalTrendMetadata.defProps, x: 0, y: 0, w: 6, h: 4 },
  { ...TotalKitsOrderedTrendMetadata.defProps, x: 6, y: 0, w: 6, h: 4 },
  { ...KitsShippedTotalTrendMetadata.defProps, x: 0, y: 4, w: 6, h: 4 },
  { ...TotalKitsShippedTrendMetadata.defProps, x: 6, y: 4, w: 6, h: 4 },
  { ...DevicesShippedTotalTrendMetadata.defProps, x: 0, y: 8, w: 6, h: 4 },
  { ...TotalDevicesShippedTrendMetadata.defProps, x: 6, y: 8, w: 6, h: 4 },
  { ...KitsShippingQueueTrendMetadata.defProps, x: 0, y: 12, w: 12, h: 4 },
  { ...KitsOrderedTrendMetadata.defProps, x: 0, y: 16, w: 6, h: 4 },
  { ...KitsShippedTrendMetadata.defProps, x: 6, y: 16, w: 6, h: 4 },
  { ...DevicesShippedTrendMetadata.defProps, x: 0, y: 20, w: 6, h: 4 },
  { ...AvgOrderToShippedTrendMetadata.defProps, x: 6, y: 20, w: 6, h: 4 },
  { ...AvgShippedToActivatedTrendMetadata.defProps, x: 0, y: 24, w: 6, h: 4 },
  { ...BulkKitsOrderedTrendMetadata.defProps, x: 6, y: 24, w: 6, h: 4 },
  { ...BulkKitsShippedTrendMetadata.defProps, x: 0, y: 28, w: 6, h: 4 },
  { ...BulkDevicesShippedTrendMetadata.defProps, x: 6, y: 28, w: 6, h: 4 },
  { ...BulkAvgOrderToShippedTrendMetadata.defProps, x: 0, y: 32, w: 6, h: 4 },
  { ...ShipmentMethodSplitMetadata.defProps, x: 6, y: 32, w: 6, h: 4 },
]);

const getEnrollmentsM = () => {
  const trendLayouts = ENROLLMENT_TREND_STATUSES.flatMap((status, index) => ([
    { ...EnrollmentEventTrendMetadata[index].defProps, x: 0, y: 16 + index * 5, w: 4, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[index].defProps, x: 4, y: 16 + index * 5, w: 5, h: 5 },
  ]));
  return [
    { ...UniquePatientsTrendMetadata.defProps, x: 0, y: 0, w: 3, h: 4 },
    { ...AvgTimeInProgramTrendMetadata.defProps, x: 3, y: 0, w: 3, h: 4 },
    { ...EligibleToEnrolledRatioMetadata.defProps, x: 6, y: 0, w: 3, h: 4 },
    { ...OnboardedToRegisteredTrendMetadata.defProps, x: 0, y: 4, w: 3, h: 4 },
    { ...RegisteredToEnrolledTrendMetadata.defProps, x: 0, y: 8, w: 3, h: 4 },
    { ...EnrolledToActivatedTrendMetadata.defProps, x: 0, y: 12, w: 3, h: 4 },
    ...trendLayouts,
    { ...DisenrollmentReasonsMetadata.defProps, x: 0, y: 46, w: 3, h: 6 },
    { ...NotEnrolledReasonsMetadata.defProps, x: 3, y: 46, w: 3, h: 6 },
    { ...NotEnrolledRecoveriesMetadata.defProps, x: 6, y: 46, w: 3, h: 6 },
  ];
};

const getOverallM = () => ([
  { ...OverallActivePatientsMetadata.defProps, x: 0, y: 0, w: 4, h: 2 },
  { ...OverallAllPatientsMetadata.defProps, x: 4, y: 0, w: 5, h: 2 },
  { ...OverallNewPatientsTrendMetadata.defProps, x: 0, y: 2, w: 9, h: 5 },
  { ...OverallNewEnrollmentsTrendMetadata.defProps, x: 0, y: 7, w: 9, h: 5 },
  { ...OverallActiveEnrollmentsTrendMetadata.defProps, x: 0, y: 12, w: 9, h: 5 },
  { ...OverallPatientsCountTrendMetadata.defProps, x: 0, y: 17, w: 9, h: 5 },
  { ...OverallDisenrollmentsTrendMetadata.defProps, x: 0, y: 22, w: 9, h: 5 },
  { ...OverallDisenrollmentReasonsTrendMetadata.defProps, x: 0, y: 27, w: 9, h: 5 },
  { ...OverallNotEnrolledTrendMetadata.defProps, x: 0, y: 32, w: 9, h: 5 },
  { ...OverallNotEnrolledReasonsTrendMetadata.defProps, x: 0, y: 37, w: 9, h: 5 },
]);

const getShipmentsM = () => ([
  { ...KitsOrderedTotalTrendMetadata.defProps, x: 0, y: 0, w: 4, h: 4 },
  { ...TotalKitsOrderedTrendMetadata.defProps, x: 4, y: 0, w: 5, h: 4 },
  { ...KitsShippedTotalTrendMetadata.defProps, x: 0, y: 4, w: 4, h: 4 },
  { ...TotalKitsShippedTrendMetadata.defProps, x: 4, y: 4, w: 5, h: 4 },
  { ...DevicesShippedTotalTrendMetadata.defProps, x: 0, y: 8, w: 4, h: 4 },
  { ...TotalDevicesShippedTrendMetadata.defProps, x: 4, y: 8, w: 5, h: 4 },
  { ...KitsShippingQueueTrendMetadata.defProps, x: 0, y: 12, w: 9, h: 4 },
  { ...KitsOrderedTrendMetadata.defProps, x: 0, y: 16, w: 4, h: 4 },
  { ...KitsShippedTrendMetadata.defProps, x: 4, y: 16, w: 5, h: 4 },
  { ...DevicesShippedTrendMetadata.defProps, x: 0, y: 20, w: 4, h: 4 },
  { ...AvgOrderToShippedTrendMetadata.defProps, x: 4, y: 20, w: 5, h: 4 },
  { ...AvgShippedToActivatedTrendMetadata.defProps, x: 0, y: 24, w: 4, h: 4 },
  { ...BulkKitsOrderedTrendMetadata.defProps, x: 4, y: 24, w: 5, h: 4 },
  { ...BulkKitsShippedTrendMetadata.defProps, x: 0, y: 28, w: 4, h: 4 },
  { ...BulkDevicesShippedTrendMetadata.defProps, x: 4, y: 28, w: 5, h: 4 },
  { ...BulkAvgOrderToShippedTrendMetadata.defProps, x: 0, y: 32, w: 4, h: 4 },
  { ...ShipmentMethodSplitMetadata.defProps, x: 4, y: 32, w: 5, h: 4 },
]);

const getEnrollmentsS = () => {
  const trendLayouts = ENROLLMENT_TREND_STATUSES.flatMap((status, index) => ([
    { ...EnrollmentEventTrendMetadata[index].defProps, x: 0, y: 39 + index * 10, w: 4, h: 5 },
    { ...EnrollmentSnapshotTrendMetadata[index].defProps, x: 0, y: 44 + index * 10, w: 4, h: 5 },
  ]));
  return [
    { ...UniquePatientsTrendMetadata.defProps, x: 0, y: 0, w: 4, h: 6 },
    { ...AvgTimeInProgramTrendMetadata.defProps, x: 0, y: 6, w: 4, h: 6 },
    { ...EligibleToEnrolledRatioMetadata.defProps, x: 0, y: 12, w: 4, h: 6 },
    { ...OnboardedToRegisteredTrendMetadata.defProps, x: 0, y: 18, w: 4, h: 7 },
    { ...RegisteredToEnrolledTrendMetadata.defProps, x: 0, y: 25, w: 4, h: 7 },
    { ...EnrolledToActivatedTrendMetadata.defProps, x: 0, y: 32, w: 4, h: 7 },
    ...trendLayouts,
    { ...DisenrollmentReasonsMetadata.defProps, x: 0, y: 99, w: 4, h: 7 },
    { ...NotEnrolledReasonsMetadata.defProps, x: 0, y: 106, w: 4, h: 7 },
    { ...NotEnrolledRecoveriesMetadata.defProps, x: 0, y: 113, w: 4, h: 7 },
  ];
};

const getOverallS = () => ([
  { ...OverallActivePatientsMetadata.defProps, x: 0, y: 0, w: 4, h: 2 },
  { ...OverallAllPatientsMetadata.defProps, x: 0, y: 2, w: 4, h: 2 },
  { ...OverallNewPatientsTrendMetadata.defProps, x: 0, y: 4, w: 4, h: 6 },
  { ...OverallNewEnrollmentsTrendMetadata.defProps, x: 0, y: 10, w: 4, h: 6 },
  { ...OverallActiveEnrollmentsTrendMetadata.defProps, x: 0, y: 16, w: 4, h: 6 },
  { ...OverallPatientsCountTrendMetadata.defProps, x: 0, y: 22, w: 4, h: 6 },
  { ...OverallDisenrollmentsTrendMetadata.defProps, x: 0, y: 28, w: 4, h: 6 },
  { ...OverallDisenrollmentReasonsTrendMetadata.defProps, x: 0, y: 34, w: 4, h: 8 },
  { ...OverallNotEnrolledTrendMetadata.defProps, x: 0, y: 42, w: 4, h: 6 },
  { ...OverallNotEnrolledReasonsTrendMetadata.defProps, x: 0, y: 48, w: 4, h: 8 },
]);

const getShipmentsS = () => ([
  { ...KitsOrderedTotalTrendMetadata.defProps, x: 0, y: 0, w: 4, h: 6 },
  { ...TotalKitsOrderedTrendMetadata.defProps, x: 0, y: 6, w: 4, h: 6 },
  { ...KitsShippedTotalTrendMetadata.defProps, x: 0, y: 12, w: 4, h: 6 },
  { ...TotalKitsShippedTrendMetadata.defProps, x: 0, y: 18, w: 4, h: 6 },
  { ...DevicesShippedTotalTrendMetadata.defProps, x: 0, y: 24, w: 4, h: 6 },
  { ...TotalDevicesShippedTrendMetadata.defProps, x: 0, y: 30, w: 4, h: 6 },
  { ...KitsShippingQueueTrendMetadata.defProps, x: 0, y: 36, w: 4, h: 6 },
  { ...KitsOrderedTrendMetadata.defProps, x: 0, y: 48, w: 4, h: 6 },
  { ...KitsShippedTrendMetadata.defProps, x: 0, y: 54, w: 4, h: 6 },
  { ...DevicesShippedTrendMetadata.defProps, x: 0, y: 60, w: 4, h: 6 },
  { ...AvgOrderToShippedTrendMetadata.defProps, x: 0, y: 66, w: 4, h: 6 },
  { ...AvgShippedToActivatedTrendMetadata.defProps, x: 0, y: 72, w: 4, h: 6 },
  { ...BulkKitsOrderedTrendMetadata.defProps, x: 0, y: 78, w: 4, h: 6 },
  { ...BulkKitsShippedTrendMetadata.defProps, x: 0, y: 84, w: 4, h: 6 },
  { ...BulkDevicesShippedTrendMetadata.defProps, x: 0, y: 90, w: 4, h: 6 },
  { ...BulkAvgOrderToShippedTrendMetadata.defProps, x: 0, y: 96, w: 4, h: 6 },
  { ...ShipmentMethodSplitMetadata.defProps, x: 0, y: 102, w: 4, h: 8 },
]);

const getDeviceUtilizationL = () => ([
  { ...KitUsageTrendMetadata.defProps, x: 0, y: 0, w: 6, h: 4 },
  { ...DeviceUsageTrendMetadata.defProps, x: 6, y: 0, w: 6, h: 4 },
  { ...AssignedKitsTrendMetadata.defProps, x: 0, y: 4, w: 6, h: 4 },
  { ...AssignedDevicesTrendMetadata.defProps, x: 6, y: 4, w: 6, h: 4 },
  { ...CapsLastTakeMetadata.defProps, x: 0, y: 8, w: 6, h: 6 },
  { ...DevicesLastActivityMetadata.defProps, x: 6, y: 8, w: 6, h: 6 },
]);

const getDeviceUtilizationM = () => ([
  { ...KitUsageTrendMetadata.defProps, x: 0, y: 0, w: 4, h: 4 },
  { ...DeviceUsageTrendMetadata.defProps, x: 4, y: 0, w: 5, h: 4 },
  { ...AssignedKitsTrendMetadata.defProps, x: 0, y: 4, w: 4, h: 4 },
  { ...AssignedDevicesTrendMetadata.defProps, x: 4, y: 4, w: 5, h: 4 },
  { ...CapsLastTakeMetadata.defProps, x: 0, y: 8, w: 9, h: 6 },
  { ...DevicesLastActivityMetadata.defProps, x: 0, y: 14, w: 9, h: 6 },
]);

const getDeviceUtilizationS = () => ([
  { ...KitUsageTrendMetadata.defProps, x: 0, y: 0, w: 4, h: 6 },
  { ...DeviceUsageTrendMetadata.defProps, x: 0, y: 6, w: 4, h: 6 },
  { ...AssignedKitsTrendMetadata.defProps, x: 0, y: 12, w: 4, h: 6 },
  { ...AssignedDevicesTrendMetadata.defProps, x: 0, y: 18, w: 4, h: 6 },
  { ...CapsLastTakeMetadata.defProps, x: 0, y: 24, w: 4, h: 6 },
  { ...DevicesLastActivityMetadata.defProps, x: 0, y: 30, w: 4, h: 6 },
]);

const getOrganizationsL = () => ([
  { ...OrgsStateMetadata.defProps, x: 0, y: 0, w: 6, h: 4 },
  { ...OrgsAdministrativeStateMetadata.defProps, x: 6, y: 0, w: 3, h: 4 },
  { ...OrgsBusinessStateMetadata.defProps, x: 9, y: 0, w: 3, h: 4 },
  { ...OrgsOperationalStateMetadata.defProps, x: 0, y: 4, w: 3, h: 4 },
  { ...NewOrganizationsByTypeMetadata.defProps, x: 3, y: 4, w: 9, h: 4 },
  { ...OrganizationsByPatientsMetadata.defProps, x: 0, y: 8, w: 6, h: 6 },
  { ...OrganizationsByEnrollmentsMetadata.defProps, x: 6, y: 8, w: 6, h: 6 },
  { ...OrganizationsByKitsOrderedMetadata.defProps, x: 0, y: 14, w: 6, h: 6 },
  { ...OrganizationsByDevicesOrderedMetadata.defProps, x: 6, y: 14, w: 6, h: 6 },
]);

const getOrganizationsM = () => ([
  { ...OrgsStateMetadata.defProps, x: 0, y: 0, w: 5, h: 4 },
  { ...OrgsAdministrativeStateMetadata.defProps, x: 5, y: 0, w: 2, h: 4 },
  { ...OrgsBusinessStateMetadata.defProps, x: 7, y: 0, w: 2, h: 4 },
  { ...OrgsOperationalStateMetadata.defProps, x: 0, y: 4, w: 3, h: 4 },
  { ...NewOrganizationsByTypeMetadata.defProps, x: 3, y: 4, w: 6, h: 4 },
  { ...OrganizationsByPatientsMetadata.defProps, x: 0, y: 8, w: 9, h: 5 },
  { ...OrganizationsByEnrollmentsMetadata.defProps, x: 0, y: 13, w: 9, h: 5 },
  { ...OrganizationsByKitsOrderedMetadata.defProps, x: 0, y: 18, w: 9, h: 5 },
  { ...OrganizationsByDevicesOrderedMetadata.defProps, x: 0, y: 23, w: 9, h: 5 },
]);

const getOrganizationsS = () => ([
  { ...OrgsStateMetadata.defProps, x: 0, y: 0, w: 4, h: 5 },
  { ...OrgsAdministrativeStateMetadata.defProps, x: 0, y: 5, w: 4, h: 5 },
  { ...OrgsBusinessStateMetadata.defProps, x: 0, y: 10, w: 4, h: 5 },
  { ...OrgsOperationalStateMetadata.defProps, x: 0, y: 15, w: 4, h: 5 },
  { ...NewOrganizationsByTypeMetadata.defProps, x: 0, y: 20, w: 4, h: 6 },
  { ...OrganizationsByPatientsMetadata.defProps, x: 0, y: 26, w: 4, h: 6 },
  { ...OrganizationsByEnrollmentsMetadata.defProps, x: 0, y: 32, w: 4, h: 6 },
  { ...OrganizationsByKitsOrderedMetadata.defProps, x: 0, y: 38, w: 4, h: 6 },
  { ...OrganizationsByDevicesOrderedMetadata.defProps, x: 0, y: 44, w: 4, h: 6 },
]);

export const getDefaultLayouts = ({ skipPermissionCheck }) => {
  return { l: getEnrollmentsL(skipPermissionCheck), m: getEnrollmentsM(skipPermissionCheck), s: getEnrollmentsS(skipPermissionCheck) };
};

export const getOverallDefaultLayouts = () => ({
  l: getOverallL(),
  m: getOverallM(),
  s: getOverallS(),
});

export const getShipmentsDefaultLayouts = ({ skipPermissionCheck }) => {
  return { l: getShipmentsL(skipPermissionCheck), m: getShipmentsM(skipPermissionCheck), s: getShipmentsS(skipPermissionCheck) };
};

export const getDeviceUtilizationDefaultLayouts = () => ({
  l: getDeviceUtilizationL(),
  m: getDeviceUtilizationM(),
  s: getDeviceUtilizationS(),
});

export const getOrganizationsDefaultLayouts = () => ({
  l: getOrganizationsL(),
  m: getOrganizationsM(),
  s: getOrganizationsS(),
});

export const numberWithTitleWidget = (
  meta,
  value,
  dashboardSettingsFeature = false,
  percent = undefined,
  unit = '',
  valueTooltip = undefined,
) => {
  const displayValue = isNaN(value) ? '-' : `${value}${unit}${isNaN(percent) ? '' : ` (${percent}%)`}`;
  return {
    ...meta,
    configuration: dashboardSettingsFeature ? meta.configuration : undefined,
    noPadding: true,
    noBorder: true,
    render: (
      <ReadingsWidget
        color='#000'
        title={meta.name}
        titleTooltip={meta.description}
        value={displayValue}
        type={WidgetTypes.plain}
        valueTooltip={valueTooltip}
      />
    ),
  };
};

// #endregion
